<div formGroupName="supplystopResultInfo">
    <mat-card class="cur-card">
        <mat-card-content>
            <!-- 上段 -->
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                    <mat-label>エネルギー種別</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.energyClsfyCodeaname" matInput
                        autocomplete="off" id="energyClsfyCodeaname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
                    <mat-label>供給地点特定番号</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.suppntSpno" matInput
                        autocomplete="off" id="suppntSpno" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]">
                    <mat-label>使用者名</mat-label>
                    <input disabled class="font-color-display-only" [value]="siyoushamei" matInput autocomplete=" off"
                        id="userMei" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                    <mat-label>作業種別</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.workClscodeAname" matInput
                        autocomplete="off" id="workClscodeAname" />
                </mat-form-field>
            </div>
            <!-- 中段 -->
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                    <mat-label>メーター番号</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterNo" matInput
                        autocomplete="off" id="meterNo" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[12%]">
                    <mat-label>型</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.metermodel" matInput
                        autocomplete="off" id="metermodel" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[12%]">
                    <mat-label>能力</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterAbility" matInput
                        autocomplete="off" id="meterAbility" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                    <mat-label>接続形態</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterCnnctformCodeaname" matInput
                        autocomplete="off" id="meterCnnctformCodeaname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]">
                    <mat-label>親／子</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterDiscrmAname" matInput
                        autocomplete="off" id="meterDiscrmAname" />
                </mat-form-field>
            </div>
            <!-- 下段 -->
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                    <mat-label>取付位置</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterInstallationlocationCodeaname" matInput
                        autocomplete="off" id="meterInstallationlocationCodeaname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                    <mat-label>内外理由メーター</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterinneroutercodeAname" matInput
                        autocomplete="off" id="meterinneroutercodeAname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[17%]">
                    <mat-label>内外理由ガス栓</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.meterGassenuchisotoCodeaname" matInput
                        autocomplete="off" id="meterGassenuchisotoCodeaname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                    <mat-label>総合／被総合</mat-label>
                    <input disabled class="font-color-display-only" [value]="suppntInfo.sougoudivCodeAname" matInput
                        autocomplete="off" id="sougoudivCodeAname" />
                </mat-form-field>

            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="cur-card">
        <mat-card-content>
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]">
                    <mat-label>支払契約番号</mat-label>
                    <input disabled class="font-color-display-only" [value]="clmtoInfo.payCtrNo" matInput
                        autocomplete="off" id="payCtrNo" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%]">
                    <mat-label>合算／まとめ</mat-label>
                    <input disabled class="font-color-display-only" [value]="clmtoInfo.totalsummaryCodeaname" matInput
                        autocomplete="off" id="totalsummaryCodeaname" />
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                    <mat-label>請求先名</mat-label>
                    <input disabled class="font-color-display-only" [value]="seikyusakimei" matInput autocomplete="off"
                        id="clmtoMei" />
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="cur-card">
        <mat-card-content>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-radio-group color="warn" (change)="onChangeWorkPlace()" formControlName="workPlaceCode"
                    class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[170px] tw-max-w-[170px] tw-min-w-[170px]"
                    style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                    <mat-label
                        style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                        作業場所 *</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S300801')"
                        style="margin-bottom: 10px!important; margin-top: 10px;">{{code.hyojiCont}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="cur-card">
        <mat-card-content>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-radio-group color="warn" (change)="onChangeSupplystopResultDivcd()"
                    formControlName="supplystopResultDivcd"
                    class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[340px] tw-max-w-[340px] tw-min-w-[340px]"
                    style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px;">
                    <mat-label
                        style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                        作業結果 *</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                        *ngFor="let code of codeMap?.get('S300771')"
                        style="margin-bottom: 10px!important; margin-top: 10px;">{{code.hyojiCont}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </mat-card-content>
    </mat-card>


    <mat-card class="cur-card"
        *ngIf="getControlvalue('workPlaceCode') == '1' && getControlvalue('supplystopResultDivcd') == '0' || getControlvalue('workPlaceCode') == '2' && getControlvalue('supplystopResultDivcd') == '0'">
        <mat-card-content
            *ngIf="getControlvalue('workPlaceCode') == '1' && getControlvalue('supplystopResultDivcd') == '0' || getControlvalue('workPlaceCode') == '2' && getControlvalue('supplystopResultDivcd') == '0'">
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>供給停止日</mat-label>
                    <input [matDatepicker]="outageDate" formControlName="supplystopDate" class="font-color-display-only"
                        matInput autocomplete="off" maxlength="10" />
                    <mat-datepicker-toggle matSuffix [for]="outageDate"
                        id="supplystopDatePickerToggle"></mat-datepicker-toggle>
                    <mat-datepicker #outageDate [startAt]="outageDate"></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]" [class.remove-top]="isEdge">
                    <mat-label>時刻</mat-label>
                    <input class="font-color-display-only" type="time" matInput formControlName="supplystopHms" [class.edge-time-input]="isEdge"
                        autocomplete="off"/>
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]">
                    <mat-label>指針 *</mat-label>
                    <input class="font-color-display-only" style="text-align:right;" matInput formControlName="duringstopShishin"
                        autocomplete="off" />
                </mat-form-field>
                <div class="tw-box-border tw-items-center tw-content-center">
                    <button type="button" (click)="onClickShishinButtonEvent.emit()" mat-raised-button color="primary"
                        class="btn tw-box-border tw-justify-end tw-items-center tw-content-center"
                        style="margin-left: 50px;" id="shishinBtn">
                        指針入力
                    </button>
                </div>
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]"
                    style="margin-left: 50px;">
                    <mat-label>使用量 *</mat-label>
                    <input [disabled]="getControl('duringstopEmpamt')?.disabled" class="font-color-display-only text-center"
                        [value]="duringstopEmpamt" matInput autocomplete="off" id="duringstopEmpamt" style="text-align:right;"   />
                </mat-form-field>
            </div>
        </mat-card-content>

        <mat-card-content
            *ngIf="getControlvalue('workPlaceCode') == '1' && getControlvalue('supplystopResultDivcd') == '0'">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-radio-group formControlName="microcontrollermeterFlashingFlg" color="warn"
                    class="search-condition-radio-frame tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[340px] tw-max-w-[340px] tw-min-w-[340px]"
                    style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px"
                    (change)="onChangeMicrocontrollermeterFlashing()">
                    <mat-label
                        style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                        マイコン点滅</mat-label>
                    <mat-radio-button class="radio-button-margin" [value]="code.value"
                        *ngFor="let code of microcontrollermeterFlashingList"
                        style="margin-bottom: 10px!important; margin-top: 10px;">{{code.viewValue}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </mat-card-content>

        <mat-card-content
            *ngIf="getControlvalue('workPlaceCode') == '1' && getControlvalue('supplystopResultDivcd') == '0'">

            <div>
                <mat-radio-group color="warn" [disabled]=false
                    class="customer-radio-group tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
                    style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px; display: block;">
                    <mat-label
                        style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;"
                        id="supplystopResultDivcdLabel">
                        供給停止結果</mat-label>


                    <div class="tw-flex tw-flex-row">
                        <div class="work-result tw-flex tw-flex-col"
                            style="margin-top: 2%; margin-left: 2%; padding-bottom: 2%;">
                            <div class="tw-flex tw-flex-row" style="width: 400px;">
                                <mat-checkbox class="check-box" color="primary" [checked]="meterPauseFlg"
                                    id="meterPauseFlg" (change)="meterPauseFlg = $event.checked"
                                    style="padding-left: 10px; padding-bottom: 30px;"
                                    [disabled]="getControl('meterPauseFlg')?.disabled">
                                    メーター休止
                                </mat-checkbox>

                                <mat-checkbox class="check-box" color="primary" [checked]="meterGasheisenstopFlg"
                                    id="meterGasheisenstopFlg" (change)="meterGasheisenstopFlg = $event.checked"
                                    style="padding-left: 30px;"
                                    [disabled]="getControl('meterGasheisenstopFlg')?.disabled">
                                    メーターガス栓閉止
                                </mat-checkbox>
                            </div>
                            <mat-checkbox class="check-box" color="primary" [checked]="supplysuspensiontimeTreatmentFlg"
                                id="supplysuspensiontimeTreatmentFlg"
                                (change)="supplysuspensiontimeTreatmentFlg = $event.checked"
                                style="padding-left: 10px; padding-bottom: 30px;"
                                [disabled]="getControl('supplysuspensiontimeTreatmentFlg')?.disabled">
                                封印措置／ロック措置
                            </mat-checkbox>
                            <div class="tw-flex tw-flex-row">
                                <mat-radio-group formControlName="efuInstallationFlg" color="warn"
                                    class="search-condition-radio-frame"
                                    style="width: 300px; position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                                    <mat-label
                                        style="margin-left: 5px;padding-right: 3px;padding-left: 3px;  position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                                        エフ取付 *</mat-label>
                                    <mat-radio-button class="radio-button-margin" [value]="code.value"
                                        *ngFor="let code of efuInstallationList"
                                        style="margin-bottom: 10px!important; margin-top: 10px;">{{code.viewValue}}</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="tw-flex tw-flex-col" style="margin-top: 2%;">
                            <mat-form-field appearance="outline"
                                class="input-form tw-box-border tw-justify-end tw-items-center tw-content-center"
                                style="min-width: 225px!important;">
                                <mat-label>閉止不能理由</mat-label>
                                <mat-select formControlName="shutoffFunoRsncod">
                                    <mat-option [value]="null" selected></mat-option>
                                    <mat-option *ngFor="let div of codeMap?.get('S300810')"
                                        [value]="div.userCode">{{div.hyojiCont}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="tw-flex tw-flex-row">
                        <mat-form-field appearance="outline"
                            class="input-form tw-box-border tw-justify-start tw-items-center tw-content-center">
                            <mat-label>供給停止書投函場所</mat-label>
                            <mat-select formControlName="supplystopdocumentPostingLocationcode">
                                <mat-option *ngFor="let div of codeMap?.get('S300820')"
                                    [value]="div.userCode">{{div.hyojiCont}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline"
                            class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]"
                            style="min-width: 170px!important;">
                            <mat-label>供給再開種別</mat-label>
                            <input class="font-color-display-only" formControlName="supplyresumptionClsfy" matInput
                                autocomplete="off" />
                        </mat-form-field>
                        <mat-form-field appearance="outline"
                            class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[10%]"
                            style="min-width: 170px!important;">
                            <mat-label>再開時の連絡要日付</mat-label>
                            <input disabled class="font-color-display-only"
                                [value]="contactRequiredOnResumeDate | dateString" matInput autocomplete="off"
                                id="contactRequiredOnResumeDate" />
                        </mat-form-field>
                        <mat-checkbox class="check-box" style="margin-right: 70%;  padding-left: 10px; margin-top: 25px;"
                            color="primary" id ="tachiaikahiSyuseiFlg"
                            [checked]="tachiaikahiSyuseiFlg"
                            (change)="tachiaikahiSyuseiFlg = $event.checked"
                            [style.visibility]="getControl('tachiaikahiSyuseiFlg')?.disabled ? 'hidden' : 'visible'">
                            <mat-label>自動再開受付対象外</mat-label>
                        </mat-checkbox>
                    </div>

                </mat-radio-group>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="cur-card" *ngIf="getControlvalue('supplystopResultDivcd') == '1'">
        <mat-card-content>

            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                style="min-width: 900px;">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>停止作業日時（変更前）</mat-label>
                    <input disabled class="font-color-display-only"
                        [value]="supplystopResultCont.bfSupplystopPlndate | dateString" matInput autocomplete="off"
                        id="bfSupplystopPlndate" />
                </mat-form-field>

                <p style="padding-left: 50px; padding-right: 50px; font: size 45px;">▶</p>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>停止作業日時（変更後）</mat-label>
                    <input [matDatepicker]="outageDate" class="font-color-display-only" formControlName="workTimeAf"
                        matInput autocomplete="off" maxlength="10" />
                    <mat-datepicker-toggle matSuffix [for]="outageDate"
                        id="workTimeAfDatePickerToggle"></mat-datepicker-toggle>
                    <mat-datepicker #outageDate [startAt]="outageDate"></mat-datepicker>
                </mat-form-field>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="cur-card">
        <mat-card-content>
            <div class="tw-flex tw-flex-row tw-box-border tw-justify-between tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[20%]">
                    <mat-label>登録日</mat-label>
                    <input disabled class="font-color-display-only"
                        [value]="supplystopResultCont.regYearmonthdate | dateString" matInput autocomplete="off"
                        id="regYearmonthdate" />
                </mat-form-field>
                <div *ngIf="isSgyshMemoVisible" class="tw-flex tw-flex-col" style="margin-top: 2%;">
                    <div class="tw-flex tw-flex-col">
                        <mat-form-field appearance="outline" style="width: 550px; margin-right: 70px;">
                            <mat-label>作業メモ</mat-label>
                            <textarea matInput style="resize: none;width: 100%;" rows="10" maxlength="500"
                                formControlName="sgyshMemo"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
        style="margin-right: 7%">
        <mat-card-actions>
            <button type="button" (click)="onClickButtonEvent.emit('payNotify')" mat-raised-button color="primary"
                class="btn" id="payNotifyButton">入金連絡受付</button>
            <button type="button" (click)="onClickButtonEvent.emit('customerInquiry')" mat-raised-button color="primary"
                class="btn" id="customerInquiryButton">お客さま照会</button>
            <button type="button" (click)="onClickButtonEvent.emit('cancel')" mat-raised-button color="primary"
                class="btn" id="cancelButton">中断</button>
            <button type="submit" [disabled]="isRegisterButtonDisabled()" mat-raised-button color="primary" class="btn"
                id="registerButton">登録</button>
        </mat-card-actions>
    </div>
</div>